import {graphql, useStaticQuery} from "gatsby";

export const useHomeData = () => {
  const { dataJson } = useStaticQuery(
    graphql`
        query {
            dataJson {
                home {
                    id
                }
                
                packages {
                    id
                    name
                    sessions
                    athletes
                    length
                    limit
                    price
                }

                reviews {
                    id
                    name {
                        en
                        ru
                        uk
                    }
                    img
                    description {
                        en
                        ru
                        uk
                    }
                }

                aboutUs {
                    options {
                        id
                        name {
                            en
                            ru
                            uk
                        }
                        img
                    }
                }
            }
        }
    `
  )
  return dataJson
}
